import React, { Component } from "react";
import "./OptionsMenuPageHeader.scss";
import closeIcon from "../../assets/images/close_icon.png";
import homeIcon from "../../assets/images/home_icon.png";
import { NavLink } from "react-router-dom";
class OptionsMenuPageHeader extends Component {
  render() {
    const { showHome, headerTitle } = this.props;
    return (
      <div className="menu-header-container">
        <div className="header-content">
          <NavLink className="header-action-icon" to="/">
            <img src={showHome ? homeIcon : closeIcon} alt="close" />
          </NavLink>
          <div className="header-title-text">{headerTitle}</div>
        </div>
      </div>
    );
  }
}

export default OptionsMenuPageHeader;
